import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { parseResponse } from '../../report.utils';
import {
  BusApiResult, BusApiStatus, BusLineOption, BusOption, BusReportCredentials,
  BusReportRequest, BusReportRow, BusRequest, BusStopOption,
} from './bus-report.models';

@Injectable({ providedIn: 'root' })
export class BusReportApiService {
  loadBuses(credentials: BusReportCredentials): Promise<BusApiResult<BusOption>> {
    return this.post<BusOption>('Bus_ListAllBuses', credentials);
  }

  loadLines(credentials: BusReportCredentials): Promise<BusApiResult<BusLineOption>> {
    return this.post<BusLineOption>('Bus_ListBusLine', credentials);
  }

  loadStops(line: string, credentials: BusReportCredentials): Promise<BusApiResult<BusStopOption>> {
    return this.post<BusStopOption>('Bus_ListBusStop4Line', { ...credentials, strCity: '0000', iBusLine: line });
  }

  loadRows(endpoint: string, payload: BusReportRequest): Promise<BusApiResult<BusReportRow>> {
    return this.post<BusReportRow>(endpoint, payload);
  }

  private async post<T>(endpoint: string, payload: BusRequest): Promise<BusApiResult<T>> {
    const response = await axios.post(endpoint, payload);
    const parsed = parseResponse<BusApiResult<T>>(response.data);
    if (Array.isArray(parsed)) return parsed;
    if (parsed && typeof parsed === 'object') {
      const status = parsed as BusApiStatus;
      if (status.ISessionExpired || status.ISSessionExpired || status.iResult === 0 || status.bError) return status;
    }
    throw new Error('Unexpected bus report response');
  }
}
